<template lang="pug">
#register
  .container
    breadcrumb(v-bind:pageName="pageName")
    #accordion.mb-5.mt-3
      h4 報名流程
      ul.process
        li 填寫完整表單資訊
        li 加入TOP巔峰籃球官方line@帳號 (@topbasketball) 確認報名資訊
        li 匯款繳費完成報名
          span.account 匯款帳戶：台灣銀行(004)-048001008932，戶名：巔峰實業有限公司 (連城分行)
        li 報名費用包含保險，餐費(全天班費用)

      h4 報名規範
      ul.process
        li 報名繳費後，請假、中途離班學費皆不得退費或轉讓。
        li 當期課程需於當期使用完畢，未上完之課程，當期結束後視同放棄。
        li 請假請提早一天告知，若當天請假，除了提出醫生證明之外，無法進行補課。
        li 補課須與班務在當期預約至其他班別進行補課，如果會在當期期末請假，請自行規劃補課時間，提前補課
        li 預約補課，無故未到，視同已補課。
        li 補課為訓練營給予同學的方便性，並非必然性，若因個人因素或無法配合補課，視同放棄權益，不另退費。
        li 因學校活動或政府活動之不可抗力因素，導致場地無法使用，當日課程調課，課程保留至下一期補課，不另退費。
        li 未續報下一期課程，將失去優惠報名資格。
        li 報名前應衡量個人體能與心理狀況，如有心血管或心臟病、癲癇症、氣喘等疾病請勿報名參加。
        li 籃球運動偶爾會有輕微運動傷害，若有任何傷害或意外發生，TOP巔峰籃球訓練營之全體工作人員無須負擔任何任何投保以外的責任與義務。

      h6 【報名辦法】
      ul.process
        li 本次活動僅採用網路報名，不接受現場報名。
        li 填寫網路報名資料後，巔峰籃球會有專人與您聯絡，請留意您的手機。
        li 連絡後確認報名成功，請使用ATM轉帳。
        li 繳費帳號逾期未繳者，若已逾報名時間，視同放棄報名資格。
        li 本次夏令營恕不提供補課方式，請報名同學準時完成課程。
        li 繳費帳號逾期未繳者，若已逾報名時間，視同放棄報名資格。
        li 若您有活動問題請洽
          span 02-29356123(與客服專員聯絡)
          span LINE ID:@topbasketball (一定要加@)
          span 聯絡時間：週一至週五(09:00-18:00)

      h6 【報名辦法】
      p 當您參加TOP巔峰籃球舉辦之活動，並完成報名及繳費後，代表您願意遵守並接受下述事項：
      p 本人同意並接受TOP 巔峰籃球訓練營活動參加規則。
        span 本人於此聲明並保證健康狀況良好，無心臟病、高血壓、糖尿病、氣喘及其它重大疾病，健康狀況適合參加本活動。
        span 本人了解運動具有一定之風險，若活動中發生任何意外事件，願自行負責。
        span 本人同意遵守本活動相關規定並配合主辦單位現場人員指導。

      h6 【注意事項】
      p 學員應著運動服裝、運動鞋、自備毛巾，並攜帶適合自己的護具及裝備。
      p 訓練營團隊有權將此活動之錄影、照片於世界各地播放、展出、登入於活動網站及刊物上，即參加學員必須同意肖像用於相關活動之宣傳與播放上。
      p 訓練營期間如遇颱風或其他不可抗力之因素，由主辦單位以學員安全為考量，有權決定是否取消或擇期或改用其他替代方案，學員不得有異議；若因故取消活動，將扣除已經產生之費用及匯款手續費後退費給學員。
      p 請參加學員檢視自己當天狀況量力而為，每日保持充足的睡眠，訓練前 1 小時完成進食。
      p 主辦單位保有取消、變更、暫停或終止本活動及相關活動之權利，如有未盡事宜，悉依主辦單位相關規定或解釋辦理，並得隨時補充公告之。

      h6 【退費說明】
      p 於開課日前7日以上提出，酌收手續費10％，於開課日前2日~7日提出，酌收手續費20％，於開課日前1日提出，酌收手續費30％，於課程第一天未到則不退費。除有重大傷病醫院證明者可退未使用之課程餘額外，其餘因個人因素而取消不接受退費。

    .row.submit-btn.mt-3.justify-content-center
      .col-md-12.text-center
        h5.agree 您是否同意以上規範
          span
            input(type="checkbox", v-model="checkBox")
          span 同意
      .col-md-12.text-center
        .send_btn(@click="toEnroll") 填寫報名表
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { errorMessage } from "@/utils/message";

export default {
  name: "EnrollStandard",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "課程報名表",
      checkBox: false,
    };
  },
  methods: {
    toEnroll() {
      if (this.checkBox) {
        this.$router.push({ name: "Enroll" });
      } else {
        errorMessage(this, "警告", "請確認是否同意以上規範");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/enroll/standard";
</style>
